import { DisplayOption, FilterableMenuItem, FilterableMenuItemArgs } from 'owa-filterable-menu';
import * as React from 'react';
import { LazyCommandingModeMenu } from 'owa-commanding-mode-menu';
import loc from 'owa-localize';
import { ribbonLayoutButtonLabel } from 'owa-locstrings/lib/strings/commandingModeMenu.locstring.json';

export function getCommandingModeMenuItem() {
    return new FilterableMenuItem({
        [FilterableMenuItemArgs.name]: loc(ribbonLayoutButtonLabel),
        [FilterableMenuItemArgs.displayOption]: DisplayOption.Left,
        [FilterableMenuItemArgs.onRender]: () => {
            return <LazyCommandingModeMenu />;
        },
    });
}
